import apiClient from './client';
import { ActorAugmentResponseMessage } from '@/types/ActorAugmentResponse';

/**
 * Updates actor (user) profile fields such as name or language.
 * Accepts query parameters corresponding to ActorSubjectMetadataMessage fields to augment.
 * Returns the updated actor subject.
 */
export async function writeActorAugment(params: {
  actorGName?: string;
  actorLName?: string;
  actorLingo?: string;
  /** If true, limits usage of personal data for personalization */
  limitUsage?: boolean;
}): Promise<ActorAugmentResponseMessage> {
  // Send augment parameters in query string; no request body
  const response = await apiClient.post<ActorAugmentResponseMessage>(
      '/secure/actor/augment', null, { params });
  return response.data;
}
